import { authRequest } from "@/services/api/http";
import {
  buildLeaderboardPath,
  buildMeUploadsPath,
  buildMyPeriodPath,
  buildMyTotalPath,
  buildPeriodLeaderboardPath,
  buildTotalLeaderboardPath,
} from "@/features/leaderboard/model/view-model";

export const getCurrentUser = () => authRequest("/auth/me");
export const logout = () => authRequest("/auth/logout", { method: "POST" });
export const getMacRelease = () => authRequest("/releases/mac/latest");
export const getLeaderboard = ({ date, provider, limit = 100, offset = 0 }) =>
  authRequest(buildLeaderboardPath(date, provider, limit, offset));
export const getTotalLeaderboard = ({ provider, limit = 100, offset = 0 }) =>
  authRequest(buildTotalLeaderboardPath(provider, limit, offset));
export const getPeriodLeaderboard = ({ period, anchor, provider, limit = 100, offset = 0 }) =>
  authRequest(buildPeriodLeaderboardPath(period, anchor, provider, limit, offset));
export const getMyUploads = ({ from, to, provider }) => authRequest(buildMeUploadsPath(from, to, provider));
export const getMyTotal = ({ provider }) => authRequest(buildMyTotalPath(provider));
export const getMyPeriod = ({ period, anchor, provider }) => authRequest(buildMyPeriodPath(period, anchor, provider));
export const getUploadTokens = () => authRequest("/upload-tokens");
export const revokeUploadToken = (id) => authRequest(`/upload-tokens/${encodeURIComponent(id)}`, { method: "DELETE" });
export const getNativeDeviceSession = (code) => authRequest(`/native/device-sessions/${encodeURIComponent(code)}`);
export const approveNativeDeviceSession = (code) =>
  authRequest(`/native/device-sessions/${encodeURIComponent(code)}/approve`, {
    method: "POST",
    json: { approve: true },
  });
